import React from 'react'
import { createRoot } from 'react-dom/client'
import { App } from './App'

export function startTranscriptDownloadMenu(data) {
  const root = createRoot(document.getElementById('transcript_menu_' + data['file_ref']))
  root.render(<App transcripts={data['transcripts']} fileref={data['file_ref']} />)
}
